import React from 'react';
import classes from './Label.css';
// import Aux from '../../hoc/Wrap/Wrap';

const label = (props) => {

    let labelTextClasses = classes.LabelText;
    let labelValueClasses = classes.LabelValue;
    let divClasses = null;

    if(props.displayType && props.displayType==='horizontal') {
        labelTextClasses = classes.LabelTextHorizontal;
        labelValueClasses = classes.LabelValueHorizontal;
        divClasses = classes.Horizontal;
    }

    // console.log("[Label]", props.labelText, props.labelValue, props.displayType);

   return(
       props.displayType ? 
         <div className={divClasses}>
             <div>
                <label className={labelTextClasses}>{props.labelText}</label>
             </div>
             <div>
                 <label className={labelValueClasses}> {props.labelValue}</label>
             </div>
         </div> 
         : ''
     );
}

export default label;